import { View } from './view'

export const DocumentList = View
